module.exports = __webpack_public_path__ + "img/destination_worldwide.6a48fa49.webp";